var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGame3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 132,
  height: 96,
  viewBox: "0 0 132 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#game3_svg__filter0_ddi_4438_2141)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.2604 67.9021C57.2404 67.7821 57.2304 67.6721 57.2104 67.5621C57.4304 67.6721 57.6404 67.7821 57.8204 67.8921C57.6204 67.8521 57.4304 67.8721 57.2704 67.9021H57.2604ZM53.4404 71.4321C53.9604 71.2421 54.3904 70.9421 54.7104 70.5221C55.1204 70.0021 55.3204 69.3921 55.3204 68.6721C55.3204 67.6321 54.9504 66.8121 54.2004 66.2321C53.4504 65.6521 52.4204 65.3521 51.0904 65.3521C50.2704 65.3521 49.4804 65.4721 48.7304 65.7221C47.9804 65.9721 47.3504 66.3221 46.8204 66.7721L47.6904 68.7521C48.1504 68.3621 48.6404 68.0621 49.1604 67.8721C49.6804 67.6821 50.2304 67.5821 50.8204 67.5821C51.4104 67.5821 51.9004 67.7021 52.2304 67.9521C52.5504 68.1921 52.7204 68.5521 52.7204 69.0121C52.7204 69.4721 52.5504 69.8621 52.2004 70.1321C51.8504 70.4021 51.3904 70.5421 50.8104 70.5421H49.0004V72.6821H51.0504C51.7204 72.6821 52.2304 72.8021 52.5704 73.0621C52.9104 73.3121 53.0804 73.6821 53.0804 74.1621C53.0804 74.6821 52.9004 75.0821 52.5404 75.3421C52.1804 75.6021 51.6404 75.7421 50.9204 75.7421C50.3004 75.7421 49.7104 75.6421 49.1304 75.4521C48.5504 75.2621 48.0004 74.9721 47.4804 74.5921L46.6304 76.6121C47.1204 77.0421 47.7604 77.3821 48.5504 77.6221C49.3404 77.8621 50.1704 77.9921 51.0304 77.9921C52.4704 77.9921 53.6004 77.6721 54.4304 77.0321C55.2604 76.3921 55.6704 75.5221 55.6704 74.4021C55.6704 73.5821 55.4404 72.8921 54.9704 72.3521C54.5804 71.9021 54.0604 71.5921 53.4204 71.4221L53.4404 71.4321ZM46.1804 68.9821H43.1004L41.2104 71.4521L39.3304 68.9821H36.2304L39.7104 73.2521L36.0104 77.8021H39.0904L41.2104 75.1021L43.3204 77.8021H46.4304L42.7404 73.2521L46.1904 68.9821H46.1804ZM101.93 67.4521L89.9004 24.0421C89.6104 23.0121 88.5803 22.3721 87.6003 22.6221L77.4904 25.1821L95.3904 57.9921C95.8204 58.7721 95.9604 59.6821 95.8004 60.5421C95.6404 61.3921 95.1904 62.1421 94.5404 62.6521C94.4004 62.7621 94.2604 62.8521 94.1104 62.9421L68.7104 76.9921C69.1704 77.4121 69.8003 77.6021 70.4203 77.4421L100.66 69.7821C101.64 69.5321 102.21 68.4921 101.92 67.4621L101.93 67.4521ZM66.8404 71.3921L62.8604 74.4921L62.2004 75.0121L61.5404 75.5321L59.8904 76.8121C59.1004 77.4221 57.9604 77.2521 57.3204 76.4221C57.5604 75.8021 57.6904 75.1321 57.6904 74.4121C57.6904 73.1821 57.3404 72.1121 56.6504 71.2321C56.6804 71.1821 56.7004 71.1221 56.7304 71.0721C56.7504 71.0921 56.7604 71.1121 56.7804 71.1321C57.6204 71.9721 59.8204 72.1821 60.3404 72.1921C60.8604 72.1921 61.5504 72.3921 61.5504 72.3921C61.5504 72.3921 61.5504 71.6621 61.6904 71.1421C61.8204 70.6321 62.2104 68.3921 61.6404 67.3421C61.0804 66.2921 59.9004 65.7421 59.0204 66.3421C59.0204 66.3421 58.4004 66.7121 58.3204 67.5021C58.1804 67.0221 58.0704 66.4421 58.0904 65.7721L57.9604 65.5921L57.0404 66.3121L56.8604 66.4521C56.5404 65.7621 56.0704 65.1621 55.4404 64.6621C54.3404 63.7921 52.8804 63.3621 51.1004 63.3621C50.0704 63.3621 49.0604 63.5221 48.1104 63.8421C48.0704 63.8521 48.0304 63.8821 47.9904 63.8921L30.4104 40.2421C29.7704 39.3821 29.9004 38.1721 30.7004 37.5521L55.3104 18.3721C56.1104 17.7521 57.2804 17.9421 57.9204 18.8021L60.0904 21.7121L60.6204 22.4221L61.1504 23.1321L65.0204 28.3421L84.7904 54.9421C85.4304 55.8021 85.3004 57.0121 84.5004 57.6321L66.8404 71.3921ZM53.4504 28.5221C54.0104 29.5721 55.1904 30.1221 56.0704 29.5221C56.0704 29.5221 56.6904 29.1521 56.7704 28.3621C56.9104 28.8421 57.0204 29.4221 57.0004 30.0921L57.1304 30.2721L58.0504 29.5521L58.9704 28.8321L58.8404 28.6521C58.2004 28.4921 57.6804 28.2321 57.2704 27.9621C58.0404 28.1021 58.5504 27.5821 58.5504 27.5821C59.3504 26.8721 59.1504 25.5621 58.3104 24.7321C57.4704 23.8921 55.2704 23.6821 54.7504 23.6721C54.2304 23.6721 53.5404 23.4721 53.5404 23.4721C53.5404 23.4721 53.5404 24.2021 53.4004 24.7221C53.2704 25.2321 52.8804 27.4721 53.4504 28.5221ZM67.3404 54.7221L66.9304 54.1721C64.9804 53.6721 63.3704 52.8821 62.1104 52.0521C64.4704 52.4621 66.0504 50.8721 66.0504 50.8721C68.5204 48.6821 67.8804 44.6821 65.3104 42.1121C62.7304 39.5421 55.9704 38.8821 54.3804 38.8721C52.7804 38.8621 50.6704 38.2621 50.6704 38.2621C50.6704 38.2621 50.6704 40.5121 50.2504 42.0921C49.8404 43.6721 48.6604 50.5121 50.3904 53.7421C52.1204 56.9721 55.7204 58.6621 58.4404 56.8121C58.4404 56.8121 60.3604 55.6821 60.6004 53.2421C61.0404 54.7021 61.3604 56.5021 61.3104 58.5621L61.7204 59.1121L67.3503 54.7221H67.3404ZM93.4904 61.2421C94.2004 60.6921 94.4003 59.6521 93.9403 58.7921L75.8304 25.6021L72.3204 19.1721C71.8104 18.2321 70.6703 17.8621 69.7803 18.3521L62.6104 22.3221L66.7603 27.9021L86.1003 53.9221C87.3203 55.5621 87.0704 57.8621 85.5404 59.0421L67.3404 73.2221L63.7504 76.0221C64.3304 76.6721 65.2604 76.8821 66.0204 76.4621L67.9403 75.4021L93.2603 61.3921C93.3403 61.3421 93.4204 61.2921 93.4904 61.2421Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "game3_svg__filter0_ddi_4438_2141",
  x: 0.00390625,
  y: -11.9921,
  width: 131.992,
  height: 119.984,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808333 0 0 0 0 0.49443 0 0 0 0 0.0235764 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2141"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2141",
  result: "effect2_dropShadow_4438_2141"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2141",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2141"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "game3_svg__yellow",
  x1: 30.0052,
  y1: 18.0079,
  x2: 82.8429,
  y2: 93.8366,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "game3_svg__gray",
  x1: 30.0052,
  y1: 18.0079,
  x2: 82.8429,
  y2: 93.8366,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgGame3 as ReactComponent };
export default __webpack_public_path__ + "assets/icons/game3.bdd758.svg";